// Locale store — Wave 7 Day 3 (i18n surface introduction).
//
// Persisted UI language preference. Default 'en' (matches Settings → Languages
// hardcoded selection state pre-wiring). Used by per-page string dictionaries
// + Languages.tsx control. V1.5+ extension: server-resolved user.locale claim
// + content i18n (orders/products). Current scope is UI text only.

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Locale = 'en' | 'tr'

type LocaleStore = {
  locale: Locale
  setLocale: (l: Locale) => void
}

export const useLocaleStore = create<LocaleStore>()(
  persist(
    (set) => ({
      locale: 'en',
      setLocale: (locale) => set({ locale }),
    }),
    { name: 'pexify-locale' },
  ),
)

// Keep <html lang> in step with the UI language. CSS `uppercase` follows it,
// so Turkish labels capitalise "i" as "İ" (GÖNDERİLDİ, not GÖNDERILDI).
function syncDocumentLang(locale: Locale) {
  if (typeof document !== 'undefined') document.documentElement.lang = locale
}
syncDocumentLang(useLocaleStore.getState().locale)
useLocaleStore.subscribe((state) => syncDocumentLang(state.locale))
